<template>
  <div style="width: 100%; height: 100%">
    <a
      v-if="!onlyMobile && pcObj"
      :href="pcObj.sgL_ImageClickUrl"
      @click="ck(pcObj.id)"
      target="_bank"
      class="pc"
    >
      <img :src="pcObj.sgL_ImageUrl" />
    </a>
    <a
      v-if="mobileObj"
      class="mobile"
      :href="mobileObj.sgL_ImageClickUrl"
      @click="ck(pcObj.id)"
      target="_bank"
    >
      <img :src="mobileObj.sgL_ImageUrl" />
    </a>
    <div v-if="isShowColse" class="colse" @click="$emit('colse')">關閉 x</div>
  </div>
</template>

<script>
export default {
  props: {
    pcObj: { type: Object },
    mobileObj: { type: Object },
    onlyMobile: { type: Boolean, required: true, default: false },
    isShowColse: { type: Boolean, required: true, default: false },
  },
  methods: {
    ck(id) {
      this.$emit("ck", id);
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
  height: 100%;
}

.pc {
  display: block !important;
  width: 100%;
  height: 100%;
}
.mobile {
  display: none !important;
  width: 100%;
  height: 100%;
}
@media (max-width: 575px) {
  .pc {
    display: none !important;
  }
  .mobile {
    display: block !important;
  }
}

.colse {
  position: absolute;
  right: 0px;
  top: 0px;
  background-color: white;
  width: 50px;
  color: royalblue;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Ad/AdBaseimg.vue